import React from 'react';
import { Card, Button, Typography, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout';

const { Title, Paragraph } = Typography;

export default function TermsAndConditionsPage() {
  const navigate = useNavigate();

  const cardStyle = {
    width: '100%',
    maxWidth: 800,
    borderRadius: 16,
    boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
  };

  return (
    <AuthLayout>
      <Card
        style={cardStyle}
        bodyStyle={{ padding: 32 }}
        title={
          <Space>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate('/login')}
              style={{ padding: 0, marginRight: 8 }}
            />
            <Title level={3} style={{ margin: 0 }}>
              Términos y Condiciones
            </Title>
          </Space>
        }
      >
        <div style={{ lineHeight: 1.8, color: '#262626' }}>
          <Paragraph style={{ marginBottom: 24 }}>
            El uso de la aplicación CHIF implica la aceptación plena y sin reservas de los presentes Términos y Condiciones. CHIF– Community Healthy Inside Fitness, propiedad de Grupo Gayazu S.A. de C.V., con domicilio en Ciudad de México (CDMX), ofrece servicios digitales de acondicionamiento físico y entrenamiento funcional mediante una plataforma móvil que permite acceder a rutinas personalizadas, material educativo y contenido especializado.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>1. Aceptación de los términos</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Al registrarse o acceder a la aplicación, el usuario reconoce haber leído, comprendido y aceptado el presente documento. Si el usuario no está de acuerdo con alguno de los términos aquí establecidos, deberá abstenerse de utilizar la aplicación.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>2. Registro del usuario</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Para utilizar los servicios, el usuario deberá proporcionar información veraz, completa y actualizada. Es responsabilidad del usuario mantener la confidencialidad de sus credenciales de acceso, así como notificar cualquier uso no autorizado de su cuenta. CHIF no se hace responsable de los daños derivados del uso indebido de las cuentas.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>3. Suscripciones y pagos</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Algunas funciones de la aplicación podrán requerir una suscripción o pago recurrente. Dichos pagos se realizarán mediante plataformas seguras de terceros y estarán sujetos a sus propias políticas. El usuario acepta los cargos periódicos asociados a su suscripción y podrá cancelarla conforme a los mecanismos disponibles dentro de la aplicación.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>4. Propiedad intelectual</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Todos los derechos sobre la marca CHIF, el software, diseño, logotipos, contenidos, textos y material audiovisual pertenecen a Grupo Gayazu S.A. de C.V. Queda estrictamente prohibido el uso, reproducción, modificación o distribución del contenido sin autorización expresa y por escrito.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>5. Exención de responsabilidad</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            CHIF proporciona información, rutinas y consejos de carácter general, los cuales no sustituyen la valoración médica profesional. El usuario reconoce que cualquier actividad física implica riesgos y libera a Grupo Gayazu S.A. de C.V. de cualquier responsabilidad derivada del uso inadecuado de la aplicación o de lesiones relacionadas con la práctica de ejercicios.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>6. Modificaciones y actualizaciones</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Grupo Gayazu S.A. de C.V. se reserva el derecho de modificar, suspender o actualizar los servicios, precios o condiciones de uso en cualquier momento. Las modificaciones surtirán efecto desde su publicación en la aplicación o en los canales oficiales de comunicación.
          </Paragraph>

          <Title level={4} style={{ marginTop: 24, marginBottom: 12 }}>7. Legislación aplicable y jurisdicción</Title>
          <Paragraph style={{ marginBottom: 16 }}>
            Los presentes Términos y Condiciones se rigen por las leyes de los Estados Unidos Mexicanos y cualquier controversia derivada de su interpretación o cumplimiento será sometida a los tribunales competentes de la Ciudad de México (CDMX).
          </Paragraph>
        </div>

        <div style={{ marginTop: 32, textAlign: 'center' }}>
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/login')}
            size="large"
          >
            Regresar al Login
          </Button>
        </div>
      </Card>
    </AuthLayout>
  );
}

